import {
  Avatar,
  Box,
  Flex,
  HStack,
  Icon,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Stack,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { signOut } from "api/auth";
import { LogoutIcon } from "assets/svg/LogoutIcon";
import { UserIcon } from "assets/svg/UserIcon";
import Alert from "generics/Alert";
import { useAuth } from "providers/AuthProvider";
import React from "react";
import { FaChevronDown } from "react-icons/fa";
import { Link as RouteLink } from "react-router-dom";

export function Toolbar() {
  const auth = useAuth();
  const signoutModal = useDisclosure();

  return (
    <Flex h="112px" p={12} w="100%" alignItems="center">
      <Alert
        confirmText="Logout"
        isOpen={signoutModal.isOpen}
        isLoading={false}
        onOk={signOut}
        title="Logout"
        message={"Are you sure you want to logout?"}
        onClose={signoutModal.onClose}
      />
      {/* This id is required for toolbar portal to be usable */}
      <Box id="toolbar-portal-container" minW="1px" flexGrow={1} pr="12"></Box>
      <Box>
        <Menu>
          <MenuButton color="grey">
            <Stack direction="row" alignItems="center">
              <Avatar
                name={auth?.lab?.name}
                src={auth?.lab?.photoUrl}
                size="sm"
              />
              <Flex>
                <Text color="grey">Hello, </Text>
                <Text fontWeight="500" color="black.500">
                  {"  "}
                  {auth?.lab?.name}
                </Text>
              </Flex>
              <Icon color="black.500" as={FaChevronDown} />
            </Stack>
          </MenuButton>
          <MenuList color="black" minW={40}>
            <Link as={RouteLink} to="/profile">
              <MenuItem px={5}>
                <HStack spacing={3}>
                  <UserIcon /> <Text>My Profile</Text>
                </HStack>
              </MenuItem>
            </Link>
            <MenuItem px={5} onClick={signoutModal.onOpen}>
              <HStack spacing={3}>
                <LogoutIcon /> <Text color="red.300">Logout</Text>
              </HStack>
            </MenuItem>
          </MenuList>
        </Menu>
      </Box>
    </Flex>
  );
}
